import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

/**
 * The house nesting rail for Registration Setup: everything a control OWNS sits
 * behind a left border, indented from the control that governs it.
 *
 * The 12px margin + 32px pad + 1px NEUTRAL_100 rule was settled by the
 * league-fee group in `forms/Payments/ProcessingFees`, where it marks the
 * fields the master switch owns. `DivisionSetup/forms/indentedGroupStyle`
 * carries the same rule for the division screen.
 *
 * NEUTRAL, not amber: this marks structure ("these belong to that"), not
 * attention.
 *
 * SN-4709 (Jeff, Sep 1) — hoisted out of ProcessingFees when General Settings
 * became a second consumer: auto-approve is now configured separately for teams
 * and for players, and each switch is nested under the registration type it
 * governs. Jeff asked for exactly this and expected a precedent to exist:
 * "there's probably some precedent."
 */
export const indentedGroupStyle = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  margin-left: 12px;
  padding-left: 32px;
  border-left: 1px solid ${colors.NEUTRAL_100};
`
